import { RootState } from '../store';

export const pastLocationSelector = (state: RootState) =>
  state.locationHistory.pastLocations;
